import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import FaqList from "../FaqList";
import { TOP_FAQS } from "../../data/business";

export default function FaqSection() {
  return (
    <section className="py-12 md:py-16 abc-bg-pale" data-testid="home-faqs">
      <div className="abc-container grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="text-xs font-bold uppercase tracking-widest text-[#54616E] mb-3">Quick answers</div>
          <h2 className="font-display text-3xl sm:text-4xl font-extrabold text-[#1A1D21]">Frequently asked questions</h2>
          <p className="mt-4 text-slate-600">The basics you probably want to know before you call.</p>
          <Link to="/faq" className="abc-btn abc-btn-outline mt-5" data-testid="home-view-faq">See all FAQs <ArrowRight className="w-4 h-4" /></Link>
        </div>
        <FaqList faqs={TOP_FAQS} testIdPrefix="home-faq" className="lg:col-span-8 space-y-3" />
      </div>
    </section>
  );
}
